import { readerDayKey } from 'utils/formatters/timezone';

export const oldestFirst = <T>(items: T[], at: (item: T) => string): T[] =>
  [...items].sort((a, b) => Date.parse(at(a)) - Date.parse(at(b)));

export const bucketByDay = <T>(items: T[], at: (item: T) => string): [string, T[]][] => {
  const byDay = new Map<string, T[]>();

  items.forEach((item) => {
    const day = readerDayKey(at(item));
    const bucket = byDay.get(day);
    if (bucket) {
      bucket.push(item);
    } else {
      byDay.set(day, [item]);
    }
  });

  return [...byDay.entries()].sort(([a], [b]) => a.localeCompare(b));
};
